export default __webpack_public_path__ + "images/card_txt.png";